// ----------------------------------------------------------------------
// <copyright file="Izenda.CommonTreeTransformer.js" company="Izenda">  Copyright (c) 2015
// Izenda, Inc.  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and  International
// Copyright Laws. Unauthorized reproduction,  reverse-engineering, and
// distribution of all or any portion of  the code contained in this file is
// strictly prohibited and may  result in severe civil and criminal penalties
// and will be  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES  ARE CONFIDENTIAL AND
// PROPRIETARY TRADE  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
// LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET  CONTROLS AS
// PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED  FILES OR ANY
// PORTION OF ITS CONTENTS SHALL AT NO TIME BE  COPIED, TRANSFERRED, SOLD,
// DISTRIBUTED, OR OTHERWISE MADE  AVAILABLE TO OTHER INDIVIDUALS WITHOUT
// EXPRESS WRITTEN CONSENT  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON  ADDITIONAL
// RESTRICTIONS. </copyright>
// ----------------------------------------------------------------------

!(function() {
  var m = require('mobx');
  const {
    isArrayLike,
    flatMap,
    invokeArgs,
    invokeMap,
    isNil,
    filter,
    every,
    isEmpty,
    escapeRegExp,
    forEach,
    isBoolean,
    reject
  } = require('lodash/fp');
  var createTransformer = function(commonTreeOption) {
    var transformer = m.createTransformer(
      function(basedNode) {
        if (isArrayLike(basedNode)) {
          return flatMap(transformer, basedNode);
        }
        return [new NodeModel(basedNode)];
      },
      function(nodeModels) {
        invokeMap('dispose', nodeModels);
      }
    );

    var NodeModel = function(basedNode) {
      var props = {
        basedNode: basedNode,
        isBranchNode: function() {
          return commonTreeOption.checkBranchNode
            ? commonTreeOption.checkBranchNode(this.basedNode)
            : !isNil(commonTreeOption.getChild(this.basedNode));
        },
        childrenNodes: function() {
          if (!this.isBranchNode) {
            return [];
          }
          return transformer(commonTreeOption.getChild(this.basedNode));
        },
        displayChildNodes: function() {
          return this.isBranchNode ? filter('isDisplayNode', this.childrenNodes) : [];
        },
        disabledCheckBox: function() {
          return (
            commonTreeOption.readOnly ||
            (commonTreeOption.disabledBranchNodeWithNoDisplayChild &&
              commonTreeOption.disabledBranchNodeWithNoDisplayChild(this.basedNode) &&
              this.isBranchNode &&
              every('disabledCheckBox', this.displayChildNodes))
          );
        },
        nodeText: function() {
          return commonTreeOption.getText(this.basedNode);
        },
        hightLightText: function() {
          return commonTreeOption.filter.text;
        },
        key: function() {
          return commonTreeOption.getKey(this.basedNode);
        },
        isDisplayNode: function() {
          var filterRegex = new RegExp(escapeRegExp(commonTreeOption.filter.text), 'i');

          var alwaysDisplay = invokeArgs('checkAlwaysDisplay', [this.basedNode], commonTreeOption);

          return (
            alwaysDisplay ||
            (commonTreeOption.checkDisplayNode(this.basedNode) &&
              (filterRegex.test(this.nodeText) || (this.isBranchNode && !isEmpty(this.displayChildNodes))))
          );
        },
        showNumChildren: function() {
          return commonTreeOption.showNumChildren
            ? commonTreeOption.showNumChildren(this.basedNode)
            : !isEmpty(this.displayChildNodes);
        },
        numberOfChildren: function() {
          return this.displayChildNodes.length;
        },
        checkboxStatus: false,
        displayCheckedStatus: function() {
          var availableCheckBox = reject('disabledCheckBox', this.displayChildNodes);

          if (isEmpty(availableCheckBox)) {
            return this.checkboxStatus && !this.disabledCheckBox ? 1 : -1;
          }
          if (every({ displayCheckedStatus: 1 }, availableCheckBox)) {
            return 1;
          }
          if (every({ displayCheckedStatus: -1 }, availableCheckBox)) {
            return -1;
          }
          return 0;
        }
      };

      m.extendObservable(this, props);

      this.dispose = m.autorun(
        function() {
          (!this.isDisplayNode || !this.disabledCheckBox) &&
            m.untracked(
              function() {
                this.checkboxStatus && (this.checkboxStatus = false);
              }.bind(this)
            );
        }.bind(this)
      );
    };

    NodeModel.prototype.check = m.action(function(check) {
      if (commonTreeOption.readOnly) {
        return;
      }
      var newCheckStatus = isBoolean(check) ? check : this.displayCheckedStatus !== 1;

      this.checkboxStatus = newCheckStatus;
      forEach(invokeArgs('check', [newCheckStatus]), reject('disabledCheckBox', this.displayChildNodes));
    });

    return transformer;
  };

  module.exports = createTransformer;
})();



// WEBPACK FOOTER //
// ./ui/share/components/controls/CommonTree/Izenda.CommonTreeTransformer.js